// Third payty and libraries
import React, { useEffect, useMemo, useState } from 'react';
import { Form, Button, Row, Col, Modal } from 'react-bootstrap';
import Select from 'react-select';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useLazyQuery, useMutation } from '@apollo/client';
import { useToasts } from "react-toast-notifications";
import _ from 'lodash';

// constant
import { HAL_KEY, LOGISTICS_DATAS, MIXAY_KEY } from '../../../../constants';
import { GET_HAL_BRANCHS, GET_MIXAY_DROP_SHIPS_V2, GET_MIXAY_PROVINCES_V2 } from '../../../../graphql/shop/shopAddress/query';
import { CREATE_USER_ADDRESS, UPDATE_USER_ADDRESS } from '../../../../graphql/userConfirm/userAddress/mutation';
import { validateMainLaotianPhoneNumber } from '../../../../helpers/validatePhone';

// Validation schema using Yup
const validationSchema = Yup.object().shape({
  userName: Yup.string().required('ຕ້ອງປ້ອນຊື່ຜູ້ຝາກ ຫຼື ຊື່ຮ້ານກ່ອນ!'),
  userTel: Yup.string()
    .required('ຕ້ອງປ້ອນເບີໂທລະສັບກ່ອນ!')
    .matches(/^\d{8}$/, 'ເບີໂທ ຕ້ອງເປັນຕົວເລກ 0 - 9 ເທົ່ານັ້ນ ບໍ່ໃສ່ 020 ຫລື 20 ດ້ານຫນ້າ'),
});

export default function FormReceiveAddress({ 
  editData, userConfirm, psid, 
  onCloseModalAdd, fetchUserAddressData, orderData }) {
  const { addToast } = useToasts();
  const [delivery, setDelivery] = useState({
    name: '',
    img: ''
  });
  const [userConfirmData, setUserConfirmData] = useState("");
  const [isModalError, setIsModalError] = useState({
    error: false,
    message: ''
  });


  useEffect(() => {
    if (userConfirm) {
      setUserConfirmData(userConfirm);
    }
  }, [userConfirm]);

  //! State for validate delivery
  const [isDelivery, setIsDelivery] = useState({
    delivery: false,
    province: false,
    district: false,
    branch: false
  });

  // state
  const [logisticsAddress, setLogisticsAddress] = useState({
    provinces: [],
    districts: [],
    villages: [],
    branchDatas: []
  })
  const [provinceOption, setProvinceOption] = useState([]);
  const [districtOption, setDistrictOption] = useState([]);
  const [villageOption, setVillageOption] = useState([]);
  const [formState, setFormState] = useState({
    _province: '',
    _district: '',
    _village: '',
    _branch: '',
    _receive_branch_id: '',
    _branch_code: '',
    _postCode: '',
    _address_detail: '',
    _dropship_start: ''
  });
  const [activeLogictics, setActiveLogictics] = useState()
  const [mixayDropShipByProvince, setMixayDropShipByProvince] = useState([])


  // apollo client query
  const [getHalBranchDatas, { data: halBranchDatas }] = useLazyQuery(GET_HAL_BRANCHS, { fetchPolicy: 'network-only' })
  // const [getMixayProvinces, { data: mixayProvinces, loading: loadingProvinceMixay }] = useLazyQuery(GET_MIXAY_PROVINCES, { fetchPolicy: 'network-only' });
  const [getMixayProvincesV2, { data: dataMixayProvincesV2 }] = useLazyQuery(GET_MIXAY_PROVINCES_V2, { fetchPolicy: 'network-only' });
  // const [getMixayDropShips, { data: mixayDropShips, loading: loadingDropshipMixay }] = useLazyQuery(GET_MIXAY_DROPSHIPS, { fetchPolicy: 'network-only' });
  const [getMixayDropShipsV2] = useLazyQuery(GET_MIXAY_DROP_SHIPS_V2, { fetchPolicy: "network-only" });

   //TODO Edit data
    const handleDefaultLogistic = (value) => {
        setActiveLogictics(value);
        switch (value) {
            case HAL_KEY:
                return {
                    value: LOGISTICS_DATAS?.hal?.keyDefault,
                    label: (
                        <div>
                        <img
                            style={{
                            width: 20,
                            height: 20,
                            marginRight: 10,
                            borderRadius: "40em",
                            }}
                            src={LOGISTICS_DATAS?.hal?.image}
                            alt={LOGISTICS_DATAS?.hal?.keyDefault}
                        />
                        {LOGISTICS_DATAS?.hal?.name}
                        </div>
                    )
                }
            case MIXAY_KEY:
                return {
                    value: LOGISTICS_DATAS?.mixay?.keyDefault,
                    label: (
                    <div>
                        <img
                        style={{ width: 20, height: 20, marginRight: 10, borderRadius: 5 }}
                        src={LOGISTICS_DATAS?.mixay?.image}
                        alt={LOGISTICS_DATAS?.mixay?.keyDefault}
                        />
                        {LOGISTICS_DATAS?.mixay?.name}
                    </div>
                    )
                }
            default:
                return null;
        }
    };
    // useMemo
    const defaultDelivery = useMemo(() => {
        const name = editData?.deliveryName;
        if (name) {
            setIsDelivery({ ...isDelivery, delivery: true });
            if (name === HAL_KEY) {
              getHalBranchDatas();
            } else if (name === MIXAY_KEY) {
              getMixayProvincesV2();
            }
            setDelivery({ name: name, img: editData?.img });
            return handleDefaultLogistic(name);
        } else return null;
    }, [editData?.deliveryName]);

  // useEffect
  useEffect(() => {
    if (halBranchDatas) {
      // Set logistics address from the response data
      setLogisticsAddress({
        provinces: halBranchDatas?.getHalBranchList?.provinces,
        districts: halBranchDatas?.getHalBranchList?.districts,
        villages: halBranchDatas?.getHalBranchList?.villages,
        branchDatas: JSON.parse(halBranchDatas?.getHalBranchList?.branchDatas),
      });

      // Map province options for react-select
      const provinceOptions = halBranchDatas?.getHalBranchList?.provinces.map(province => ({
        value: province.id,
        label: province.name
      }));
      setProvinceOption(provinceOptions);

      // Map village options for react-select
      const villageOptions = halBranchDatas?.getHalBranchList?.villages.map(village => ({
        value: village.id,
        label: village.name
      }));

      setVillageOption(villageOptions);


    }
    if (!_.isEmpty(dataMixayProvincesV2)) {
      let mixayProvinceOptions = dataMixayProvincesV2?.getMixayProvincesV2?.provinces.map(province => ({
        value: province.id,
        label: province.name
      }));
      setProvinceOption(mixayProvinceOptions);
    }
  }, [halBranchDatas, dataMixayProvincesV2]);

  // apollo client mutation
  const [addUserAddressAPI, { loading: addUserAddressLoading }] = useMutation(CREATE_USER_ADDRESS);
  const [putUserAddressAPI, { loading: putUserAddressLoading }] = useMutation(UPDATE_USER_ADDRESS);

  //TODO create user address
  const handleProcessAPI = async (values) => {
    try {
      if (addUserAddressLoading || putUserAddressLoading) return;
      if (!isDelivery.branch) {
        // handleAlert("ກະລຸນາເລືອກຂົນສົ່ງ-ສາຂາ!", "warning");
        setIsModalError((prev) => ({ ...prev, error: true, message: "ກະລຸນາເລືອກຂົນສົ່ງ-ສາຂາ!"}));
        return;
      }

      // validate phone
      if (!validateMainLaotianPhoneNumber(values?.userTel)) {
        // handleAlert("ກະລຸນາປ້ອນເບີໂທໃຫ້ຖືກ!", "warning");
        setIsModalError((prev) => ({ ...prev, error: true, message: "ກະລຸນາປ້ອນເບີໂທໃຫ້ຖືກ!"}));
        return;
      }

      // Receive Or User Address
      let dataRequest = {
        ...values,
        user: userConfirmData?.id,
        deliveryName: delivery?.name,
        img: delivery?.img,
        province: formState._province,
        district: formState?._district,
        village: formState?._village,
        branch: formState?._branch,
        branchCode: formState?._branch_code,
        receive_branch_id: formState?._receive_branch_id,
        labelAs: "Delivery",
        address: `${formState?._branch_code}-${formState?._branch}(${formState?._village}-${formState?._district}-${formState?._province})`,
        postcode: formState?._postCode,
      };
      // remove column logistics in dataRequest
      delete dataRequest.logistics;
      if (delivery?.name === MIXAY_KEY) {
          dataRequest = {...dataRequest, 
            address: formState?._address_detail ?
              formState?._address_detail 
              : formState?._branch_code + "-" + formState?._village + "-" + formState?._district + "-" + formState?._province,
            postcode: formState?._postCode,
            dropship_start: formState?._dropship_start,
          };
        if(_.isEmpty(dataRequest?.address)) {
          setIsModalError((prev) => ({ ...prev, error: true, message: "ບໍ່ສາສມາດສ້າງຂົນສົ່ງມີໄຊ, ກະລຸນາລອງໃຫມ່ພາຍຫລັງ!"}));
          return;
        }
        delete dataRequest.receive_branch_id;
      } else{
        if (dataRequest?.receive_branch_id < 0) {
          setIsModalError((prev) => ({ ...prev, error: true, message: "ບໍ່ສາສມາດສ້າງຂົນສົ່ງຮຸ່ງອາລຸນ, ກະລຸນາລອງໃຫມ່ພາຍຫລັງ!"}));
          return;
        }
      }

      if(editData?.id) { 
        await putUserAddressAPI({
          variables: {
            where: { id: editData?.id, deliveryName: delivery?.name, user: userConfirmData?.id },  
            data: dataRequest
          }
        })
        handleAlert("ແກ້ໄຂທີ່ຢູ່ສຳລັບການຈັດສົ່ງ ສຳເລັດ", "success");
      } else {  
        await addUserAddressAPI({
          variables: {
            data: dataRequest
          }
        })
        handleAlert("ສ້າງທີ່ຢູ່ສຳລັບການຈັດສົ່ງ ສຳເລັດ", "success");
      }
      await fetchUserAddressData();
      handleUseEffect();
      onCloseModalAdd();
      return;
    } catch (error) {
      // handleAlert("ຂໍອະໄພ ບໍ່ສາມາດ ສ້າງໃຊ້ທີ່ຢູ່ສຳລັບການຈັດສົ່ງ ກະລຸນາລອງໃຫມ່ພາຍຫລັງ", "error");
      console.log("ERROR_handleProcessAPI: ", error);
      if (error?.message === "Error: DUPLICATE_ADDRESS") {
        setIsModalError((prev) => ({...prev, error: true, message: "ຂໍອະໄພ ບໍ່ສາມາດ ສ້າງຫລືແກ້ໄຂທີ່ຢູ່ສຳລັບການຈັດສົ່ງທີ່ຊຳກັນ ກະລຸນາລອງໃຫມ່ພາຍຫລັງ"}));
      } else {
        setIsModalError((prev) => ({...prev, error: true, message: "ຂໍອະໄພ ບໍ່ສາມາດ ສ້າງຫລືແກ້ໄຂທີ່ຢູ່ສຳລັບການຈັດສົ່ງ ກະລຸນາລອງໃຫມ່ພາຍຫລັງ"}));
      }
    }
  };

  const handleAlert = (message, appearance) => {
    addToast(message, {
      appearance: appearance,
      autoDismiss: true,
    });
  }

  // get mixay dropships
  const handleMixayDropShip = async (id) => {
    try {
      const response = await getMixayDropShipsV2({
        variables: {
          where: {
            provinceId: id,
          },
        },
      });
      if (!_.isEmpty(response?.data)) {
        const _resDropShip = JSON.parse(
          response?.data?.getMixayDropShipsV2?.branchDatas
        );

        // Create a Set to store unique district names
        const uniqueDistricts = new Set();

        // Filter the districts and map them to the options format, ensuring each district name is unique
        const provinceOptions = _resDropShip
          .filter((district) => {
            const isUnique = !uniqueDistricts.has(district?.dristric?.dr_id);
            uniqueDistricts.add(district?.dristric?.dr_id); // Add the district name to the set
            return isUnique;
          })
          .map((district) => {
            return {
            value: district?.dristric?.dr_id, //district.id,
            label: district?.dristric?.dr_name //district.dristric,
          }});

        // Set the district options
        // setIsDelivery({ ...isDelivery, province: true });
        setDistrictOption(provinceOptions);
        setMixayDropShipByProvince(_resDropShip)
      }
    } catch (error) {
      console.log("Error in handleMixayDropShip:", error);
      handleAlert("ພົບຂໍ້ຜີດຜາດ ບໍ່ພົບຂໍມູນສາຂາ", "error");
      return;
    }
  };

  // handle change get logistics
  const handleChange = (selectedOption, setFieldValue) => {
    setFieldValue('logistics', selectedOption);
    setActiveLogictics(selectedOption?.value);
    setIsDelivery({ ...isDelivery, delivery: true, province: false, district: false, branch: false});
    if (selectedOption?.value === HAL_KEY) {
      setDelivery({ name: "HAL", img: selectedOption?.img });
      getHalBranchDatas();
      // setIsDelivery({ ...isDelivery, delivery: true });
    } else if (selectedOption?.value === MIXAY_KEY) {
      setDelivery({ name: "MIXAY", img: selectedOption?.img });
      // setIsDelivery({ ...isDelivery, delivery: true, province: !isDelivery?.province, district: !isDelivery?.district, branch: !isDelivery?.branch });
      // getMixayProvinces()
      getMixayProvincesV2();
    } else {
      setProvinceOption()
      setDistrictOption()
      setVillageOption()
    }
  };

  // select province to filter district alls
  const onChangeProvince = (value, setFieldValue) => {
    setFieldValue('province', value);
    setFormState({ ...formState, _province: value?.label });
    setIsDelivery({ ...isDelivery, province: true, district: false, branch: false});

    switch (activeLogictics) {
      case MIXAY_KEY:
        // Handle MIXAY_KEY logic
        handleMixayDropShip(value?.value);
        break;

      case HAL_KEY:
        // Handle HAL_KEY logic
        const _districtOptions = logisticsAddress?.districts.filter(data => data?.province_id === value?.value);

        const provinceOptions = _districtOptions.map(district => ({
          value: district.id,
          label: district.name
        }));
        setDistrictOption(provinceOptions);
        break;

      default:
        // Handle any other keys or default logic if needed
        break;
    }
  }

  // select district to filter branch alls
  const onChangeDistrict = async (value, setFieldValue) => {
    setFieldValue('district', value);
    if (!logisticsAddress?.branchDatas || !value) return;

    setFormState({ ...formState, _district: value?.label });
    setIsDelivery({ ...isDelivery, district: true, branch: false });


    switch (activeLogictics) {
      case MIXAY_KEY:
        // Handle MIXAY_KEY logic
        handleMixayDistrict(value?.value);
        break;

      case HAL_KEY:
        // Handle HAL_KEY logic
        const _villageOptions = logisticsAddress.branchDatas.filter(data => {
          return Number(data?.district_id) === Number(value?.value);
        });

        const _branchOption = _villageOptions.map(branch => ({
          value: branch?.id,
          label: branch?.name,
          code: branch?.code,
        }));

        setVillageOption(_branchOption);
        break;

      default:
        // Handle any other keys or default logic if needed
        break;
    }
  };

  // select branch data
  const onChangeBranch = (value, setFieldValue) => {
    setFieldValue('village', value);
    if (activeLogictics === MIXAY_KEY) {
      const _newBranch = mixayDropShipByProvince.filter((b) => b?.code === value?.value);
      setFormState({ ...formState, _village: _newBranch[0]?.village?.vill_name, 
        _province: _newBranch[0]?.province?.pr_name, _district: _newBranch[0]?.dristric?.dr_name,
        _branch: _newBranch[0]?.name, _branch_code: _newBranch[0]?.code, _dropship_start: _newBranch[0]?.id,
        _postCode: _newBranch[0]?.postcode, _address_detail: _newBranch[0]?.address_detail });
      setIsDelivery({ ...isDelivery, branch: true });
      return;
    }

    setFormState({ ...formState, _village: value?.label, _branch: value?.label, _receive_branch_id: value?.value, _branch_code: value?.code });
    setIsDelivery({ ...isDelivery, branch: true });
  };

  // filter branch in province for mixay
  const handleMixayDistrict = (_keyFilter) => {
    const _dropShipOptions = mixayDropShipByProvince.filter((data) => {
      return data?.dristric?.dr_id === _keyFilter;
    });
    if (!_.isEmpty(_dropShipOptions)) {
      const _branchOption = _dropShipOptions.reduce((options, branch) => {
        options.push({
          value: branch?.code,
          label: branch?.name,
        });
        return options;
      }, []);
      setVillageOption(_branchOption);
    }
  }

  function handleUseEffect() {
    setIsDelivery ({
      delivery: false,
      province: false,
      district: false,
      branch: false
    });
  }

  return (
    <>
      <Formik
        initialValues={{ 
          userName: editData?.userName ?? orderData?.cfName ?? orderData?.customerName ?? '', 
          userTel: editData?.userTel ?? userConfirmData?.phone ?? '', codNumber: editData?.codNumber ?? '',
          logistics: defaultDelivery,
          province: { value: 0, label: editData?.province } ?? null,
          district: { value: 0, label: editData?.district } ?? null,
          village: { value: 0, label: editData?.branch ?? editData?.village ?? null } ?? null,
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleProcessAPI(values)
        }}
      >
        {({ handleSubmit, setFieldValue, values }) => (
          <Form noValidate onSubmit={handleSubmit}>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>ຂົນສົ່ງ</Form.Label>
                  <Select
                    isDisabled={editData?.deliveryName ? true : false}
                    options={logisticsOptions}
                    onChange={(selectedOption) => handleChange(selectedOption, setFieldValue)}
                    placeholder="-ເລືອກ-"
                    value={values.logistics}
                  />
                  {(isDelivery?.delivery || editData?.deliveryName) ? null : (<p className="text-danger" >ກະລຸນາເລືອກຂົນສົ່ງ</p>)}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>ແຂວງ</Form.Label>
                  <Select
                    options={provinceOption}
                    onChange={(value) => onChangeProvince(value, setFieldValue)}
                    placeholder="-ເລືອກ-"
                    value={values.province}
                    isDisabled={!isDelivery?.delivery ? true : false}
                  />
                  {(!isDelivery?.province) ? (<p className="text-danger" >ກະລຸນາເລືອກຂົນສົ່ງກ່ອນ</p>) : null}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>ເມືອງ</Form.Label>
                  <Select
                    options={districtOption}
                    onChange={(value) => onChangeDistrict(value, setFieldValue)}
                    placeholder="-ເລືອກ-"
                    value={values?.district}
                    isDisabled={!isDelivery?.province ? true : false}
                  />
                  {!isDelivery?.district ? (<p className="text-danger" >ກະລຸນາເລືອກແຂວງກ່ອນ</p>) : null}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>ສາຂາ</Form.Label>
                  <Select
                    options={villageOption}
                    onChange={(value) => onChangeBranch(value, setFieldValue)}
                    placeholder="-ເລືອກ-"
                    value={values.village}
                    isDisabled={!isDelivery?.district ? true : false}
                  />
                  {!isDelivery?.district ? (<p className="text-danger" >ກະລຸນາເລືອກເມືອງກ່ອນ</p>) :
                    !isDelivery?.branch ? (<p className="text-danger" >ກະລຸນາເລືອກສາຂາ</p>) : null}
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>ຊື່ຜູ້ຮັບ(ຈາກFacebook)</Form.Label>
              <Field disabled={orderData?.cfName ? true : false} name="userName" className="form-control" type="text" 
                maxLength={20} pattern="[0-9]{20}"
                placeholder="ຈຳນວນ 20 ຕົວອັກສອນເທົ່ານັ້ນ"
              />
              <ErrorMessage name="userName" component="div" className="text-danger" />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>ເບີໂທຜູ້ຮັບ</Form.Label>
              <Field name="userTel" className="form-control" type="text" maxLength={8} pattern="[0-9]{8}"
                placeholder="ໃສ່ເບີໂທລະສັບ 8 ຕົວເລກ" />
              <ErrorMessage name="userTel" component="div" className="text-danger" />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>ລະຫັດ COD (ຖ້າມີ)</Form.Label>
              <Field
                name="codNumber"
                className="form-control"
                type="text"
                maxLength={10} pattern="[0-9]{10}"
                placeholder="ຈຳນວນ 10 ຕົວອັກສອນເທົ່ານັ້ນ"
              />
              <ErrorMessage name="codNumber" component="div" className="text-danger" />
            </Form.Group>

            <div className='w-100 d-flex justify-content-end align-items-center gap-2'>

              <Button 
                disabled={(addUserAddressLoading || putUserAddressLoading) ? true : false}
                type="button" variant='light' onClick={() => {onCloseModalAdd(); setIsDelivery({
                delivery: false,
                province: false,
                district: false,
                branch: false
              });}}>ຍົກເລີກ</Button>
              <Button type="submit" variant='info' disabled={(addUserAddressLoading || putUserAddressLoading) ? true : false}>{(addUserAddressLoading || putUserAddressLoading) ? "loading..." : "ບັນທຶກຂໍ້ມູນ"}</Button>
            </div>

          </Form>
        )}
      </Formik>
      {/* Modal error */}
      <Modal centered show={isModalError?.error} onHide={() => setIsModalError({ ...isModalError, error: false, message: '' })} size='lg' >
        <Modal.Header closeButton 
          className={'bg-danger text-white'}
        >
            <Modal.Title>ເພີ່ມທີ່ຢູ່ສຳລັບການຈັດສົ່ງ</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-5">
            <p>{isModalError?.message}</p>
        </Modal.Body> 
      </Modal>
    </>
  );
}

const logisticsOptions = [
  {
    value: LOGISTICS_DATAS?.mixay?.keyDefault,
    label: (
      <div>
        <img
          style={{ width: 20, height: 20, marginRight: 10, borderRadius: '40em' }}
          src={LOGISTICS_DATAS?.mixay?.image}
          alt={LOGISTICS_DATAS?.mixay?.keyDefault}
        />
        {LOGISTICS_DATAS?.mixay?.name}
      </div>
    ),
    img: LOGISTICS_DATAS?.mixay?.image,
  },

  {
    value: LOGISTICS_DATAS?.hal?.keyDefault,
    label: (
      <div>
        <img
          style={{ width: 20, height: 20, marginRight: 10, borderRadius: '40em' }}
          src={LOGISTICS_DATAS?.hal?.image}
          alt={LOGISTICS_DATAS?.hal?.keyDefault}
        />
        {LOGISTICS_DATAS?.hal?.name}
      </div>
    ),
    img: LOGISTICS_DATAS?.hal?.image,
  },

  // {
  //   value: LOGISTICS_DATAS?.anusith?.keyDefault,
  //   label: (
  //     <div>
  //       <img
  //         style={{ width: 20, height: 20, marginRight: 10, borderRadius: '40em' }}
  //         src={LOGISTICS_DATAS?.anusith?.image}
  //         alt={LOGISTICS_DATAS?.anusith?.keyDefault}
  //       />
  //       {LOGISTICS_DATAS?.anusith?.name}
  //     </div>
  //   ),
  //   img: LOGISTICS_DATAS?.anusith?.image,
  // },

];
